import { Link } from "react-router-dom";
import { GameButton } from "../components/GameButton";

const places = [
  { name: "Arena", detail: "Feed the fight", className: "hotspot--arena", to: "/arena" },
  { name: "Forge", detail: "Let the bad idea cook", className: "hotspot--forge", to: "/forge" },
  { name: "Library", detail: "The receipts live here", className: "hotspot--library", to: "/discover" },
  { name: "Shop", detail: "Acquire suspicious parcels", className: "hotspot--shop", to: "/account" },
  { name: "House", detail: "Display the hoard", className: "hotspot--house", to: "/account" },
  { name: "Exchange", detail: "Trade real cards", className: "hotspot--exchange", to: "/market" },
  { name: "Terminal", detail: "Chase the Founder", className: "hotspot--terminal", to: "/terminal" },
];

export function WorldPage() {
  return (
    <div className="world-page world-page--immersive page-scene">
      <div className="environment-plate environment-plate--island" aria-hidden="true" />
      <div className="scene-heading">
        <p className="eyebrow">No routes. No menus. Just doors.</p>
        <h1>Welcome to Forge Island.</h1>
        <p>Seven buildings. Three shores. An alarming number of things with teeth.</p>
      </div>
      <div className="island-map island-map--immersive" aria-label="Interactive map of Forge Island, Exchange island, and Founder’s Terminal">
        {places.map((place) => (
          <Link key={place.name} to={place.to} className={`island-hotspot ${place.className}`}>
            <strong>{place.name}</strong><span>{place.detail}</span>
          </Link>
        ))}
      </div>
      <div className="world-hoard-cta"><GameButton to="/account" tone="sea">Visit my hoard</GameButton></div>
    </div>
  );
}
